import { type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useBffPatchMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { Basket } from './model';

export const useUpdateBasket = (): UseMutationResult<Basket, unknown, Basket> => {
    const { data } = useBasket();
    const queryClient = useQueryClient();

    return useBffPatchMutation<Basket, Basket>(`/baskets/${data?.basketId}`, [], [], {
        basketCustomerId: data?.customerInfo?.customerId,
        onSuccess: (basket) => {
            queryClient.setQueryData([BffQueryKey.BASKET], basket);
        },
    });
};
